import $ from 'jquery';

class BackgroundImage{

    constructor(src, container){
		this.src = src;
		this.container = container;
		this.image = new Image();
		this.show();

    }

    show(){
        
        $(this.container).css("background-image",`url(${this.src})`);

        let src = $(this.container).css("background-image");

        let url = src.match(/\((.*?)\)/)[1].replace(/('|")/g,'');      

        this.image.onload = ()=>{

            $(this.container).fadeIn("slow");

        }

        this.image.src = url;

        if(this.image.complete){

            this.image.onload();

        }   
        
    }


}

export default BackgroundImage;